/* Captured from a real Android handset (LAVA LXX504, Android 15) over adb —
   not an emulator and not a mockup.

   PERSONAL DATA IS REDACTED. Names, email addresses, phone numbers, OTPs and
   the whole of the SMS/message content are pixelated, not merely blurred: the
   earlier blur was cosmetic and macOS Vision OCR read `abdul@gmail.com`
   straight through it. Redaction is verified by re-running OCR over the output
   and asserting nothing personal comes back. UI chrome is deliberately left
   legible so the screens still document the app.

   Keyed by module slug. Regenerate from public/docs/android rather than
   hand-editing. */
const ANDROID_SCREENS = {
  "login": [
    {
      "src": "/docs/android/00-login/after-login.webp",
      "kind": "after-login",
      "label": "Signed in"
    },
    {
      "src": "/docs/android/00-login/login-filled.webp",
      "kind": "login-filled",
      "label": "Credentials entered"
    }
  ],
  "dashboard": [
    {
      "src": "/docs/android/01-dashboard/dashboard.webp",
      "kind": "dashboard",
      "label": "Home"
    },
    {
      "src": "/docs/android/01-dashboard/menu.webp",
      "kind": "menu",
      "label": "Navigation drawer"
    },
    {
      "src": "/docs/android/01-dashboard/period-this-month.webp",
      "kind": "period-this-month",
      "label": "This month"
    },
    {
      "src": "/docs/android/01-dashboard/period-this-week.webp",
      "kind": "period-this-week",
      "label": "This week"
    },
    {
      "src": "/docs/android/01-dashboard/period-today.webp",
      "kind": "period-today",
      "label": "Today"
    }
  ],
  "notifications": [
    {
      "src": "/docs/android/02-notifications/list.webp",
      "kind": "list",
      "label": "List"
    }
  ],
  "customers": [
    {
      "src": "/docs/android/03-customers/add-customer.webp",
      "kind": "add-customer",
      "label": "Add customer"
    },
    {
      "src": "/docs/android/03-customers/detail-activities.webp",
      "kind": "detail-activities",
      "label": "Activities"
    },
    {
      "src": "/docs/android/03-customers/detail-followups.webp",
      "kind": "detail-followups",
      "label": "Follow-ups"
    },
    {
      "src": "/docs/android/03-customers/detail-logs.webp",
      "kind": "detail-logs",
      "label": "Logs"
    },
    {
      "src": "/docs/android/03-customers/detail-opportunities.webp",
      "kind": "detail-opportunities",
      "label": "Opportunities"
    },
    {
      "src": "/docs/android/03-customers/detail.webp",
      "kind": "detail",
      "label": "Customer detail"
    },
    {
      "src": "/docs/android/03-customers/list.webp",
      "kind": "list",
      "label": "List"
    },
    {
      "src": "/docs/android/03-customers/tab-all-customers.webp",
      "kind": "tab-all-customers",
      "label": "All customers"
    }
  ],
  "sip-call": [
    {
      "src": "/docs/android/04-sip-call/campaign-select.webp",
      "kind": "campaign-select",
      "label": "Pick a campaign"
    },
    {
      "src": "/docs/android/04-sip-call/change-campaign.webp",
      "kind": "change-campaign",
      "label": "Switch campaign"
    },
    {
      "src": "/docs/android/04-sip-call/dialer-open.webp",
      "kind": "dialer-open",
      "label": "Dialer"
    },
    {
      "src": "/docs/android/04-sip-call/dialer.webp",
      "kind": "dialer",
      "label": "Dialer"
    },
    {
      "src": "/docs/android/04-sip-call/status-picker.webp",
      "kind": "status-picker",
      "label": "Agent status"
    },
    {
      "src": "/docs/android/04-sip-call/tab-call-log.webp",
      "kind": "tab-call-log",
      "label": "Call log"
    },
    {
      "src": "/docs/android/04-sip-call/tab-customers.webp",
      "kind": "tab-customers",
      "label": "Queue"
    },
    {
      "src": "/docs/android/04-sip-call/tab-followups.webp",
      "kind": "tab-followups",
      "label": "Follow-ups"
    },
    {
      "src": "/docs/android/04-sip-call/tab-performance.webp",
      "kind": "tab-performance",
      "label": "Performance"
    }
  ],
  "tasks": [
    {
      "src": "/docs/android/05-tasks/detail.webp",
      "kind": "detail",
      "label": "Customer detail"
    },
    {
      "src": "/docs/android/05-tasks/edit.webp",
      "kind": "edit",
      "label": "Edit task"
    },
    {
      "src": "/docs/android/05-tasks/list.webp",
      "kind": "list",
      "label": "List"
    },
    {
      "src": "/docs/android/05-tasks/status-contacted.webp",
      "kind": "status-contacted",
      "label": "Contacted"
    },
    {
      "src": "/docs/android/05-tasks/status-followup.webp",
      "kind": "status-followup",
      "label": "Follow-up"
    },
    {
      "src": "/docs/android/05-tasks/status-new-lead.webp",
      "kind": "status-new-lead",
      "label": "New lead"
    }
  ],
  "messages": [
    {
      "src": "/docs/android/06-messages/list.webp",
      "kind": "conversation",
      "label": "Conversation"
    },
    {
      "src": "/docs/android/06-messages/list.webp",
      "kind": "list",
      "label": "List"
    },
    {
      "src": "/docs/android/06-messages/list.webp",
      "kind": "tab-group",
      "label": "Group chats"
    }
  ],
  "sms": [
    {
      "src": "/docs/android/07-sms/list.webp",
      "kind": "list",
      "label": "List"
    },
    {
      "src": "/docs/android/07-sms/tab-read.webp",
      "kind": "tab-read",
      "label": "Read"
    },
    {
      "src": "/docs/android/07-sms/tab-unread.webp",
      "kind": "tab-unread",
      "label": "Unread"
    },
    {
      "src": "/docs/android/07-sms/thread.webp",
      "kind": "thread",
      "label": "Thread"
    }
  ],
  "support": [
    {
      "src": "/docs/android/08-support/list.webp",
      "kind": "list",
      "label": "List"
    },
    {
      "src": "/docs/android/08-support/my-tickets.webp",
      "kind": "my-tickets",
      "label": "My tickets"
    }
  ],
  "offline-sync": [
    {
      "src": "/docs/android/09-offline-sync/status.webp",
      "kind": "status",
      "label": "Sync status"
    }
  ],
  "profile": [
    {
      "src": "/docs/android/10-profile/edit-profile.webp",
      "kind": "edit-profile",
      "label": "My profile"
    }
  ]
};

export default ANDROID_SCREENS;
